import * as Types from '../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type QueryTextureSetRevisionViewTextureSetDataQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type QueryTextureSetRevisionViewTextureSetDataQuery = { __typename: 'Query', textureSet: { __typename: 'TextureSet', id: string, textureGroup: { __typename: 'TextureGroup', organization: { __typename: 'Organization', legacyId: number } } } };

export type QueryTextureSetRevisionViewRevisionDataQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type QueryTextureSetRevisionViewRevisionDataQuery = { __typename: 'Query', textureSetRevision: { __typename: 'TextureSetRevision', name?: string | null, width: number, height: number, displacement?: number | null, textureSet: { __typename: 'TextureSet', id: string }, mapAssignments: Array<{ __typename: 'TextureSetRevisionMapAssignment', textureType: Types.TextureType, dataObject: { __typename: 'DataObject', id: string } }> } };

export type TextureSetRevisionViewTextureSetFragment = { __typename: 'TextureSet', id: string, textureGroup: { __typename: 'TextureGroup', organization: { __typename: 'Organization', legacyId: number } } };

export type TextureSetRevisionViewCreateTextureSetRevisionMutationVariables = Types.Exact<{
  input: Types.MutationCreateTextureSetRevisionInput;
}>;


export type TextureSetRevisionViewCreateTextureSetRevisionMutation = { __typename: 'Mutation', createTextureSetRevision: { __typename: 'TextureSetRevision', id: string } };

export const TextureSetRevisionViewTextureSetFragmentDoc = gql`
    fragment TextureSetRevisionViewTextureSet on TextureSet {
  id
  textureGroup {
    organization {
      legacyId
    }
  }
}
    `;
export const QueryTextureSetRevisionViewTextureSetDataDocument = gql`
    query queryTextureSetRevisionViewTextureSetData($id: ID!) {
  textureSet(id: $id) {
    ...TextureSetRevisionViewTextureSet
  }
}
    ${TextureSetRevisionViewTextureSetFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class QueryTextureSetRevisionViewTextureSetDataGQL extends Apollo.Query<QueryTextureSetRevisionViewTextureSetDataQuery, QueryTextureSetRevisionViewTextureSetDataQueryVariables> {
    override document = QueryTextureSetRevisionViewTextureSetDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const QueryTextureSetRevisionViewRevisionDataDocument = gql`
    query queryTextureSetRevisionViewRevisionData($id: ID!) {
  textureSetRevision(id: $id) {
    textureSet {
      id
    }
    name
    width
    height
    displacement
    mapAssignments {
      textureType
      dataObject {
        id
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class QueryTextureSetRevisionViewRevisionDataGQL extends Apollo.Query<QueryTextureSetRevisionViewRevisionDataQuery, QueryTextureSetRevisionViewRevisionDataQueryVariables> {
    override document = QueryTextureSetRevisionViewRevisionDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TextureSetRevisionViewCreateTextureSetRevisionDocument = gql`
    mutation textureSetRevisionViewCreateTextureSetRevision($input: MutationCreateTextureSetRevisionInput!) {
  createTextureSetRevision(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TextureSetRevisionViewCreateTextureSetRevisionGQL extends Apollo.Mutation<TextureSetRevisionViewCreateTextureSetRevisionMutation, TextureSetRevisionViewCreateTextureSetRevisionMutationVariables> {
    override document = TextureSetRevisionViewCreateTextureSetRevisionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }